import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function usePersistentState(key, defaultValue = 1, options = {}) {
  const {
    mode = "storage",
    storageType = "session",
  } = options;

  const [searchParams, setSearchParams] = useSearchParams();

  const getStorage = () =>
    storageType === "local" ? localStorage : sessionStorage;

  const getInitialValue = () => {
    if (mode === "url") {
      return Number(searchParams.get(key)) || defaultValue;
    }
    if (mode === "storage") {
      return Number(getStorage().getItem(key)) || defaultValue;
    }
    return defaultValue;
  };

  const [value, setValue] = useState(getInitialValue);

  useEffect(() => {
    if (mode === "url") {
      setSearchParams((prev) => {
        prev.set(key, value);
        return prev;
      });
    } else if (mode === "storage") {
      getStorage().setItem(key, value);
    }
  }, [value, key, mode]);

  return [value, setValue];
}
